var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appShell",staticClass:"app-shell",attrs:{"id":"appShell"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view')],1),_c('div',{ref:"toast",staticClass:"toast",attrs:{"id":"gcToast"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }